import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { NOTIFICATION_SERVICE } from '@eggplant/api-hosts'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type {
  Error,
  GetTestManagementIntegrationQuery,
  TestManagementToolInputs
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  children?: (response: TestManagementToolInputs[]) => ReactElement
  onError?: (error: Error) => void
  onSuccess?: (notificationSettings: TestManagementToolInputs[]) => void
  params?: GetTestManagementIntegrationQuery
}

const GetTestManagementIntegrationsRequest = ({
  children,
  onError,
  onSuccess,
  params
}: Props) => {
  const { requestParams } = useGetParamsWithSpaceId<GetTestManagementIntegrationQuery|undefined>(params)

  const url = `${NOTIFICATION_SERVICE}/integrations`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={requestParams}
      url={url}
    />
  )
}

export default GetTestManagementIntegrationsRequest
